export default __webpack_public_path__ + "static/media/Icon44.6be62415.svg";